import { BodyChangeRelationship } from 'mutation/view-models/registration-citizenship';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyChangeRelationship, keyof BodyChangeRelationship>[] = [
  {
    id: 'fiscalCode',
    label: 'Codice Fiscale',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'dateBorn',
    label: 'Data di nascita',
  },
  {
    id: 'placeBorn',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'relationship',
    label: 'Parentela',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
